import React from 'react'
import { Typography, Card, CardContent } from '@material-ui/core'
import Rating from '@material-ui/lab/Rating'
import { Timestamp } from '@firebase/firestore'

const ReviewCard = ({ review }) => {

    return (
        <Card elevation={6}>
            <CardContent>

                {review?.name && (
                    <Typography gutterBottom variant="body1">
                        {review.name}
                    </Typography>
                )}

                {review?.timestamp && (
                    <Typography gutterBottom variant="subtitle2">
                        {new Timestamp(review.timestamp.seconds, review.timestamp.nanoseconds).toDate().toLocaleDateString('en-US')}
                    </Typography>
                )}

                {review?.rating && (
                    <div>
                        <Typography component="legend">Rating: {review.rating}</Typography>
                        <Rating name="read-only" value={review.rating} readOnly />
                    </div>
                )}

                {review?.description && (
                    <Typography gutterBottom variant="body1">
                        {review.description}
                    </Typography>
                )}

            </CardContent>
        </Card>
    )
}

export default ReviewCard